import { render, staticRenderFns } from "./SubscriptionNotices.vue?vue&type=template&id=35124880"
import script from "./SubscriptionNotices.vue?vue&type=script&lang=js"
export * from "./SubscriptionNotices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports